import { buildNum } from "../../../utils/format";

export default [
    // #1 - #10
    [
        {type: 'currency', name: 'event_log', amount: 300}
    ],
    [
        {type: 'building', name: 'collector', level: 1, amount: 1}
    ],
    [
        {type: 'currency', name: 'event_coconut', amount: 1000}
    ],
    [
        {type: 'currency', name: 'event_log', amount: 1750},
        {type: 'currency', name: 'event_coconut', amount: 3000}
    ],
    [
        {type: 'building', name: 'mainStage', level: 1, amount: 1}
    ],
    [
        {type: 'currency', name: 'event_music', amount: 1300}
    ],
    [
        {type: 'currency', name: 'event_log', amount: 7000},
        {type: 'currency', name: 'event_coconut', amount: 7000}
    ],
    [
        {type: 'building', name: 'collector', level: 2, amount: 2}
    ],
    [
        {type: 'currency', name: 'event_music', amount: buildNum(14, 'K')}
    ],
    [
        {type: 'building', name: 'vegetablePatch', level: 1, amount: 1}
    ],

    // #11 - #20
    [
        {type: 'building', name: 'collector', level: 3, amount: 2}
    ],
    [
        {type: 'currency', name: 'event_vegetable', amount: 1500}
    ],
    [
        {type: 'currency', name: 'event_music', amount: buildNum(50, 'K')}
    ],
    [
        {type: 'building', name: 'vegetablePatch', level: 2, amount: 1}
    ],
    [
        {type: 'building', name: 'collector', level: 3, amount: 4}
    ],
    [
        {type: 'currency', name: 'event_stoneBlock', amount: buildNum(900, 'K')}
    ],
    [
        {type: 'building', name: 'sawmill', level: 1, amount: 1}
    ],
    [
        {type: 'currency', name: 'event_solidPlate', amount: 10}
    ],
    [
        {type: 'currency', name: 'event_coconut', amount: buildNum(7, 'M')},
        {type: 'currency', name: 'event_vegetable', amount: 4000}
    ],
    [
        {type: 'building', name: 'kitchen', level: 1, amount: 1}
    ],

    // #21 - #30
    [
        {type: 'currency', name: 'event_coconutSalad', amount: 25}
    ],
    [
        {type: 'currency', name: 'event_music', amount: buildNum(130, 'K')}
    ],
    [
        {type: 'currency', name: 'event_shell', amount: buildNum(16, 'M')}
    ],
    [
        {type: 'currency', name: 'event_log', amount: buildNum(150, 'M')},
        {type: 'currency', name: 'event_coconut', amount: buildNum(200, 'M')},
        {type: 'currency', name: 'event_stoneBlock', amount: buildNum(80, 'M')}
    ],
    [
        {type: 'building', name: 'mainStage', level: 2, amount: 1}
    ],
    [
        {type: 'currency', name: 'event_music', amount: buildNum(360, 'K')}
    ],
    [
        {type: 'currency', name: 'event_rawMeat', amount: 20}
    ],
    [
        {type: 'currency', name: 'event_solidPlate', amount: 3000},
        {type: 'currency', name: 'event_coconutSalad', amount: 650},
        {type: 'currency', name: 'event_rawMeat', amount: 80}
    ],
    [
        {type: 'building', name: 'vegetablePatch', level: 3, amount: 2}
    ],
    [
        {type: 'currency', name: 'event_sand', amount: buildNum(40, 'K')}
    ],

    // #31 - #40
    [
        {type: 'currency', name: 'event_sandstone', amount: 600}
    ],
    [
        {type: 'currency', name: 'event_coal', amount: 100}
    ],
    [
        {type: 'building', name: 'huntingArea', level: 1, amount: 2}
    ],
    [
        {type: 'currency', name: 'event_music', amount: buildNum(900, 'K')}
    ],
    [
        {type: 'currency', name: 'event_cookedMeat', amount: 200}
    ],
    [
        {type: 'building', name: 'collector', level: 7, amount: 2}
    ],
    [
        {type: 'currency', name: 'event_salt', amount: 900}
    ],
    [
        {type: 'currency', name: 'event_coconutSalad', amount: 3000},
        {type: 'currency', name: 'event_saltyShell', amount: 100}
    ],
    [
        {type: 'currency', name: 'event_music', amount: buildNum(2.5, 'M')}
    ],
    [
        {type: 'building', name: 'mainStage', level: 3, amount: 1}
    ],
];
